import { CircularProgress } from '@mui/material';

import { Z_INDEX_OVERLAY } from 'constants/ui/style';

const Overlay = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        backgroundColor: '#ffffffb3',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'green',
        zIndex: Z_INDEX_OVERLAY,
      }}
    >
      <CircularProgress size="large" />
    </div>
  );
};

export default Overlay;
